module.exports = __webpack_public_path__ + "static/franc-7b7d8e9eac37b185f94a130facce5068.jpg";